// Paket-Texte, mit CourseType und dann CourseIntensity (siehe app/data/pricing.ts).
const de = {
  tierNames: {
    light: "Light",
    semiIntensive: "Semi-Intensiv",
    intensive: "Intensiv",
  },

  groupCourses: {
    light: {
      description:
        "Ein einsteigerfreundlicher Kurs mit einem lockereren Zeitplan.",
      features: [
        "Live-Onlineunterricht einmal pro Woche",
        "Fragerunden nach jedem Unterricht",
        "Zugriff auf aufgezeichnete Sitzungen",
        "Karriereberatung alle 3 Monate",
        "Abschlusszertifikat",
        "Zugang zur Community-Gruppe",
        "Monatliche Fortschrittsberichte",
      ],
    },
    semiIntensive: {
      description:
        "Mehr Beteiligung mit zusätzlichem Live-Unterricht und Karriereinhalten.",
      features: [
        "Live-Onlineunterricht zweimal pro Woche",
        "Fragerunden nach jedem Unterricht",
        "Zugriff auf aufgezeichnete Sitzungen",
        "Monatliche Karriereberatung",
        "Vorbereitung auf Vorstellungsgespräche (zweimonatlich)",
        "Gruppenprojekte mit Feedback",
        "Lernmaterialien und Ressourcen",
      ],
    },
    intensive: {
      description: "Der intensivste Gruppenkurs mit persönlicher Betreuung.",
      features: [
        "Live-Onlineunterricht viermal pro Woche",
        "Fragerunden nach jedem Unterricht",
        "Zugriff auf aufgezeichnete Sitzungen",
        "Karriereberatung alle zwei Wochen",
        "Vorbereitung auf Vorstellungsgespräche (monatlich)",
        "Gruppenprojekte mit Betreuung",
        "Exklusive Webinare und Workshops",
      ],
    },
  },

  individualCourses: {
    light: {
      description:
        "Ein flexibler Kurs mit individuellen Plänen und moderater Interaktion.",
      features: [
        "Individueller Lernplan",
        "Live-Onlineunterricht einmal pro Woche",
        "Fragerunde nach jedem Unterricht",
        "Zugriff auf aufgezeichnete Sitzungen",
        "Karriereberatung alle 3 Monate",
        "Persönliches Projekt-Feedback",
        "Lernmaterialien und Ressourcen",
      ],
    },
    semiIntensive: {
      description: "Häufigere Einzelbetreuung und fachkundiges Mentoring.",
      features: [
        "Individueller Lernplan",
        "Live-Onlineunterricht zweimal pro Woche",
        "Fragerunde nach jedem Unterricht",
        "Monatliche Karriereberatung",
        "Projektbetreuung und fachkundiges Feedback",
        "Vorbereitung auf Vorstellungsgespräche (monatlich)",
        "Bevorzugte Lernmaterialien",
      ],
    },
    intensive: {
      description:
        "Ein Rundum-Programm mit fachkundigem Mentoring und Unterstützung.",
      features: [
        "Individueller Lernplan",
        "Live-Onlineunterricht viermal pro Woche",
        "Fragerunde nach jedem Unterricht",
        "Karriereberatung alle zwei Wochen",
        "Ausführliche Projektbetreuung",
        "Vorbereitung auf Vorstellungsgespräche (zweiwöchentlich)",
        "Bevorzugter Support per E-Mail und Chat",
      ],
    },
  },
};

export default de;
